'use client'

import { MktCodeSnippet } from '~/components/mkt/code-snippet'
import { DeveloperExperience } from '.'
import { Language } from 'prism-react-renderer'

export const ClientSideSnippets = ({
  snippets,
  links,
}: {
  snippets: DeveloperExperience['snippets']['items']
  links?: DeveloperExperience['links'] | null
}) => {
  const firstSnippet = snippets[0]

  return (
    <MktCodeSnippet
      value={firstSnippet?._title ?? ''}
      links={links?.map((l) => ({
        href: l.href,
        label: l.label,
        icon: l.icon?.svg,
      }))}
      snippets={snippets.map((s) => {
        return {
          selectValue: s._title,
          snippet: {
            language: s.codeSnippet.language as Language,
            icon: s.icon,
            label: s._title,
            code: s.codeSnippet.code,
          },
        }
      })}
    />
  )
}
